import { useStore } from '@xyflow/react'
import { FlowNodeTypes } from '../types'
import { isAiConversationNode } from '../utils/ai-agent-utils'

export const useHasAINode = () => {
  // A retired Skills node still counts, so agents that had the resource tabs keep them
  return useStore((state) =>
    state.nodes.some(
      (node) => isAiConversationNode(node.type) || node.type === FlowNodeTypes.ai_skills,
    ),
  )
}
